<template>
  <div class="Home">
    <h1>{{msg}}</h1>
  </div>
</template>

<script>
export default {
  name: 'Billing',
  data () {
    return {
      msg: 'Welcome to billing'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/billing.vue